import { Box, Grid, Toolbar, Typography } from "@mui/material";
import React from "react";
import { LOCALE } from "../../properties/Locale";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";

export default function Footer() {
  const auth = useSelector((state) => state.auth);
  const theme = useTheme();

  return (
    <Toolbar
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "10px 20px",
        position: "relative",
      }}
    >
      <Grid container sx={{ flexGrow: 1 }}>
        <Grid item xs={7}>
          <Box
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "830px",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              "&::after": {
                content: '""',
                position: "absolute",
                right: 0,
                top: 0,
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0))",
                zIndex: 1,
              },
            }}
          >
            {Array.from({ length: 10 }).map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: "83px",
                  height: "100%",
                  background: `linear-gradient(-45deg, #f0dec4a8 50%, transparent 0), linear-gradient(45deg, #5c95f180 50%, transparent 0)`,
                  opacity: 0.3,
                }}
              />
            ))}
          </Box>
        </Grid>
        {!auth?.userData && (
          <Grid item xs={auth?.userData ? 4.45 : 4.14}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                ml: "auto",
                justifyContent: "flex-end",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "right",
                  padding: "10px 0",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    fontFamily: "Inter-Regular",
                    fontSize: "10px",
                    lineHeight: "0.8",
                    color: theme.palette.secondary.main,
                    textTransform: "uppercase",
                    letterSpacing: "0.4px",
                    opacity: "1",
                    padding: "2px 5px 0 0",
                  }}
                >
                  Министерство за транспорт
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    lineHeight: "1.1",
                    color: theme.palette.secondary.main,
                    mt: "3px",
                    wordBreak: "break-word",
                    width: "330px",
                    padding: "1px 5px",
                  }}
                >
                  {LOCALE.systemName}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    lineHeight: "1.1",
                    color: theme.palette.secondary.main,
                    wordBreak: "break-word",
                    padding: "1px 5px",
                  }}
                >
                  Е-пошта: info@mtc.gov.mk
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    lineHeight: "1.1",
                    color: theme.palette.secondary.main,
                    wordBreak: "break-word",
                    padding: "1px 5px",
                  }}
                >
                  Адреса: Црвена Скопска Општина 4, 1000 Скопје
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    lineHeight: "1.1",
                    color: theme.palette.secondary.main,
                    wordBreak: "break-word",
                    cursor: "pointer",
                    padding: "1px 5px",
                    cursor: "pointer",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                  onClick={() => window.open("https://mtc.gov.mk", "_blank")}
                >
                  mtc.gov.mk
                </Typography>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Toolbar>
  );
}
